import Reflux from 'reflux';
import { AppActions, NotificationActions } from 'actions';
import SteelCompass from 'services/SteelCompass';
import { notificationPageLength } from 'Constants';

const NotificationStore = Reflux.createStore({
  listenables: [NotificationActions],
  data: {
    unreadNotifications: 0,
    list: []
  },
  getInitialState() {
    return this.data;
  },
  onRead(includeRead, callback) {
    return SteelCompass.request(
      'notifications',
      'read',
      {
        reversed: false,
        includeRead,
        types: []
      },
      0,
      notificationPageLength
    )
      .then(response => {
        NotificationActions.readComplete(response.data);
        if (callback) {
          callback();
        }
      })
      .catch(console.log);
  },
  onReadComplete(data) {
    this.data.list = data;
    this.trigger(this.data);
  },
  onMarkRead(ids) {
    return SteelCompass.call('notifications', 'markRead', { ids }, response => {
      if (ids && ids.length) {
        var lookup = {};
        ids.forEach(id => {
          lookup[id] = true;
        });
        this.data.list.forEach(item => {
          if (lookup[item.id]) {
            item.isRead = true;
          }
        });
        this.trigger(this.data);
      }
      this.countUnreadNotifications();
    });
  },
  countUnreadNotifications() {
    SteelCompass.request('notifications', 'count', {}).then(
      data => {
        if (data !== undefined && data !== null) {
          NotificationActions.countUnreadNotificationsComplete(data);
        } else {
          AppActions.genericError();
        }
      },
      error => {
        AppActions.genericError(error);
      }
    );
  },
  countUnreadNotificationsComplete(unreadNotifications) {
    if (this.data.unreadNotifications !== unreadNotifications) {
      this.data = {
        ...this.data,
        unreadNotifications
      };
      this.trigger(this.data);
    }
  }
});

export default NotificationStore;



// WEBPACK FOOTER //
// ./src/js/stores/Notification.js